export default {
  title: 'Maksa {{method}}',
  hint: 'Napauta alla olevaa painiketta ja hyväksy maksu {{method}}-ikkunassa.',
  confirming: 'Vahvistetaan maksua…',
  cancel: 'Peruuta maksu',
  unavailable: 'Tämä maksutapa ei ole juuri nyt käytettävissä. Valitse toinen.',
  approval_timeout:
    'Emme saaneet vastausta palvelusta {{method}}. Jos sen ikkuna ei avautunut, tarkista että ponnahdusikkunat ovat sallittuja, ja yritä sitten uudelleen tai valitse toinen maksutapa.',
};
